import React from 'react';
import { PaginatorProvider } from '../../../providers/Paginator';
import Compras from './index';
import withAuthenticationRequired from "../../ProtectedRoutes/withAuthenticationRequired";
import Loading from "../../Loading";

const ComprasWrapper = () => (
  <PaginatorProvider>
    <Compras />
  </PaginatorProvider>
);

export default withAuthenticationRequired(ComprasWrapper, {
  onRedirecting: () => <Loading />,
});